import { Fragment } from "react/jsx-runtime";
import { Grid, Typography } from "@mui/material";
import { ToolFunction } from "@my-helpers/common";
import { Parameter } from "./Parameter";

interface FunctionContainerProps {
    func: ToolFunction;
    funcIndex: number;
}

export const FunctionContainer: React.FC<FunctionContainerProps> = ({ func, funcIndex }) => {

    return (
        <Fragment key={funcIndex}>
            <Grid 
                size={2} 
                display="flex" 
                flexDirection="column" 
                padding={1.5} 
                gap={0.5} 
                sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    backgroundColor: 'background.paper'
                }}>
                <Typography variant="body2">
                    {func.name}
                </Typography>
                <Typography
                    variant="body2"
                    fontSize="0.8rem"
                    color="text.secondary" >
                    {func.description}
                </Typography>
            </Grid>

            {/* Parameters */}
            {func.parameters && typeof func.parameters === 'object' &&
                (func.parameters as any).properties &&
                Object.keys((func.parameters as any).properties).length > 0 ? (
                <Grid 
                    size={10} 
                    display="flex" 
                    flexDirection="column"  
                    flex={1} 
                    minWidth={0} 
                    justifyContent="flex-start"
                    sx={{
                        overflowX: 'auto'
                    }}>
                    {Object.entries((func.parameters as any).properties || {}).map(([key, param]: [string, any]) => (
                        <Parameter
                            key={key}
                            parameterName={key}
                            parameter={param}
                            required={(func.parameters as any)?.required?.includes(key)}
                        />
                    ))}
                </Grid>

            ) : (
                <Grid size={12} sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 60
                }}>
                    <Typography variant="body2" color="text.disabled" sx={{ fontStyle: 'italic' }}>
                        No parameters
                    </Typography>
                </Grid>
            )}
        </Fragment>
    );
};